import { Switch as SwitchPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Switch({
  className,
  size = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: 'sm' | 'default'
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        `peer group/switch focus-visible:border-ring focus-visible:ring-ring/50
        data-[state=checked]:bg-primary data-[state=unchecked]:bg-input
        inline-flex shrink-0 items-center rounded-full border border-transparent
        shadow-xs transition-all outline-none focus-visible:ring-[3px]
        disabled:cursor-not-allowed disabled:opacity-70
        data-[size=default]:h-[1.15rem] data-[size=default]:w-8
        data-[size=sm]:h-3.5 data-[size=sm]:w-6`,
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          `bg-background pointer-events-none block rounded-full ring-0
          transition-transform group-data-[size=default]/switch:size-4
          group-data-[size=sm]/switch:size-3
          data-[state=checked]:translate-x-[calc(100%-2px)]
          data-[state=unchecked]:translate-x-0`,
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
